<app-iframe [url]="url" (callbackMessageReceived)="onCallbackMessageReceived($event)"
    [supportEsploravinoUiEnumeraReadyMessageEvent]="true"></app-iframe>